module.exports = __webpack_public_path__ + "media/bootstrap-icons/stop-circle-fill-1cb12ee4.svg";